import { Link } from 'react-router-dom';
import './JyotishLink.scss';

const JyotishLinks = () => {
  return (
    <div className="jyotish-links">
      <h2>Jyotish</h2>
      <div className="card-grid">

        <Link to="/jyotish/kundali" className="card">
          <div className="img-part">
            <img src="https://5.imimg.com/data5/ANDROID/Default/2024/5/418723878/EQ/ZJ/CE/5214546/product-jpeg-500x500.jpg" alt="Kundali" />
          </div>
          <div className="text-part">
            <h3>Kundali</h3>
            <p>Detailed birth chart and planetary positions.</p>
          </div>
        </Link>

        <Link to="/jyotish/matchmaking" className="card">
          <div className="img-part">
            <img src="https://5.imimg.com/data5/ANDROID/Default/2024/5/418723878/EQ/ZJ/CE/5214546/product-jpeg-500x500.jpg" alt="Matchmaking" />
          </div>
          <div className="text-part">
            <h3>Matchmaking</h3>
            <p>Check compatibility for marriage and relationships.</p>
          </div>
        </Link>

        <Link to="/jyotish/janma-kundali" className="card">
          <div className="img-part">
            <img src="https://5.imimg.com/data5/ANDROID/Default/2024/5/418723878/EQ/ZJ/CE/5214546/product-jpeg-500x500.jpg" alt="Janma Kundali" />
          </div>
          <div className="text-part">
            <h3>Janma Kundli</h3>
            <p>Birth details with Lagna, Rashi, and Nakshatra.</p>
          </div>
        </Link>

        {/* <Link to="/jyotish/rashifal" className="card">
          <div className="img-part">
            <img src="https://5.imimg.com/data5/ANDROID/Default/2024/5/418723878/EQ/ZJ/CE/5214546/product-jpeg-500x500.jpg" alt="Rashifal" />
          </div>
          <div className="text-part">
            <h3>Rashifal</h3>
            <p>Daily, weekly, and monthly horoscope predictions.</p>
          </div>
        </Link> */}

        <Link to="/jyotish/moonsign" className="card">
          <div className="img-part">
            <img src="https://5.imimg.com/data5/ANDROID/Default/2024/5/418723878/EQ/ZJ/CE/5214546/product-jpeg-500x500.jpg" alt="Moonsign" />
          </div>
          <div className="text-part">
            <h3>Moonsign</h3>
            <p>Discover your Rashi based on moon position.</p>
          </div>
        </Link>

        <Link to="/jyotish/sunsign" className="card">
          <div className="img-part">
            <img src="https://5.imimg.com/data5/ANDROID/Default/2024/5/418723878/EQ/ZJ/CE/5214546/product-jpeg-500x500.jpg" alt="Sunsign" />
          </div>
          <div className="text-part">
            <h3>Sunsign</h3>
            <p>Find your Western zodiac (sun sign) details.</p>
          </div>
        </Link>

        <Link to="/jyotish/name-initials" className="card">
          <div className="img-part">
            <img src="https://5.imimg.com/data5/ANDROID/Default/2024/5/418723878/EQ/ZJ/CE/5214546/product-jpeg-500x500.jpg" alt="Name Initials" />
          </div>
          <div className="text-part">
            <h3>Name Initials</h3>
            <p>Check auspicious initials based on Nakshatra.</p>
          </div>
        </Link>

        <Link to="/jyotish/baby-name-finder" className="card">
          <div className="img-part">
            <img src="https://5.imimg.com/data5/ANDROID/Default/2024/5/418723878/EQ/ZJ/CE/5214546/product-jpeg-500x500.jpg" alt="Baby Name Finder" />
          </div>
          <div className="text-part">
            <h3>Baby Name Finder</h3>
            <p>Suggest baby names based on birth star.</p>
          </div>
        </Link>

        <Link to="/jyotish/pancha-paki" className="card">
          <div className="img-part">
            <img src="https://5.imimg.com/data5/ANDROID/Default/2024/5/418723878/EQ/ZJ/CE/5214546/product-jpeg-500x500.jpg" alt="Pancha Paki" />
          </div>
          <div className="text-part">
            <h3>Pancha Pakshi</h3>
            <p>Five-fold energy theory-based calculator.</p>
          </div>
        </Link>

        <Link to="/jyotish/mangal-dasha" className="card">
          <div className="img-part">
            <img src="https://5.imimg.com/data5/ANDROID/Default/2024/5/418723878/EQ/ZJ/CE/5214546/product-jpeg-500x500.jpg" alt="Mangal Dasha" />
          </div>
          <div className="text-part">
            <h3>Mongal Dasha</h3>
            <p>Analyze Mars' influence in your horoscope.</p>
          </div>
        </Link>

        <Link to="/jyotish/kalsarpa-yoga" className="card">
          <div className="img-part">
            <img src="https://5.imimg.com/data5/ANDROID/Default/2024/5/418723878/EQ/ZJ/CE/5214546/product-jpeg-500x500.jpg" alt="Kalsarpa Yoga" />
          </div>
          <div className="text-part">
            <h3>Kalsarpa Yoga</h3>
            <p>Check for dosha caused by planetary positions.</p>
          </div>
        </Link>

        <Link to="/jyotish/janma-lagna" className="card">
          <div className="img-part">
            <img src="https://5.imimg.com/data5/ANDROID/Default/2024/5/418723878/EQ/ZJ/CE/5214546/product-jpeg-500x500.jpg" alt="Janma Lagna" />
          </div>
          <div className="text-part">
            <h3>Janma Lagna</h3>
            <p>Find your ascendant sign at the time of birth.</p>
          </div>
        </Link>

        <Link to="/jyotish/sraddha-calculator" className="card">
          <div className="img-part">
            <img src="https://5.imimg.com/data5/ANDROID/Default/2024/5/418723878/EQ/ZJ/CE/5214546/product-jpeg-500x500.jpg" alt="Sraddha Calculator" />
          </div>
          <div className="text-part">
            <h3>Sraddha Calculator</h3>
            <p>Determine Shraddha dates based on death tithi.</p>
          </div>
        </Link>

        <Link to="/jyotish/sahasra-chandradaya" className="card">
          <div className="img-part">
            <img src="https://5.imimg.com/data5/ANDROID/Default/2024/5/418723878/EQ/ZJ/CE/5214546/product-jpeg-500x500.jpg" alt="Sahasra Chandradaya" />
          </div>
          <div className="text-part">
            <h3>Sahasra Chandradaya</h3>
            <p>Find the 1000th full moon day from birth.</p>
          </div>
        </Link>

      </div>
    </div>
  );
};

export default JyotishLinks;
